module.exports = __webpack_public_path__ + "media/images/event/image_07-559d01db9ae16026b83ebd0d27f016a9.png";